import React, { useEffect, useRef } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { VideoModalWrapper } from "./styled";

const VideoModal = ({ isOpen, onClose, videoSrc, videoTitle }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "auto";
      videoRef.current?.pause();
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <VideoModalWrapper>
      <div className="custom-video-modal" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close-btn" onClick={onClose}>
            <CloseOutlined />
          </button>
          <div className="modal-video-wrapper">
            <video
              ref={videoRef}
              src={videoSrc}
              controls
              autoPlay
              title={videoTitle}
              className="modal-video"
            />
          </div>
          <div className="modal-footer">
            {videoTitle}
          </div>
        </div>
      </div>
    </VideoModalWrapper>
  );
};

export default VideoModal;
